var React = require('react');

function KbdTab (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 12h-1.39V4H16v8zm-2.781-4L9.16 12V8.685H0v-1.37h9.16V4l4.059 4z"}));
}

KbdTab.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = KbdTab;

KbdTab.default = KbdTab;
